module.exports = __webpack_public_path__ + "static/media/John S. McCain - 2008.1cd575f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/John S. McCain - 2008.jpg
// module id = 526
// module chunks = 0